<template>
  <v-layout :class="{'pt-0' : $vuetify.breakpoint.xsOnly, 'pt-5 mt-5' : !$vuetify.breakpoint.xsOnly}">
    <v-flex xs12 sm11 offset-sm1>
      <v-layout row v-if="error">
        <v-flex xs12>
          <app-alert @dismissed="onDismissed" :text="error.message" :color="error.colour"></app-alert>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <div class="app-panel white py-4" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
            <span class="subheading d-block mb-3">Customer payments</span>
            <customer-payments/>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import CustomerPayments from '@/components/Shared/CustomerPayments'
export default {
  components: {
    CustomerPayments
  },
  computed: {
    error () {
      return this.$store.getters.error
    }
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  },
  created () {
    this.$store.dispatch('reloadGroup')
  }
}
</script>
